import { styled } from '@mui/material';

export const StyledImage = styled('img')(({ theme }) => ({
  padding: theme.spacing(0.5),
  height: theme.spacing(4)
}));

export const StyledDiv = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(5.5),
  height: theme.spacing(4)
}));
